import React from 'react';
import LegalPageLayout from '../layouts/LegalPageLayout';
import SEO from '../components/SEO';

const SECTIONS = [
    { id: 'general',      label: 'General Terms' },
    { id: 'license',      label: 'License' },
    { id: 'definitions',  label: 'Definitions & Key Terms' },
    { id: 'restrictions', label: 'Restrictions' },
    { id: 'payment',      label: 'Payment' },
    { id: 'refund',       label: 'Return & Refund Policy' },
    { id: 'consent',      label: 'Your Consent' },
    { id: 'links',        label: 'Links to Other Websites' },
    { id: 'cookies',      label: 'Cookies' },
    { id: 'changes',      label: 'Changes to Terms' },
    { id: 'contact',      label: 'Contact Us' },
];

const h2 = { fontSize: '1.2rem', fontWeight: '800', color: '#1A1A2E', margin: '0 0 12px', fontFamily: 'Calibri, sans-serif' };
const divider = { borderTop: '2px solid rgba(173,20,87,0.1)', margin: '0 0 24px' };
const p = { color: '#475569', lineHeight: '1.8', marginBottom: '12px', fontFamily: 'Calibri, sans-serif' };
const li = { color: '#475569', lineHeight: '2', fontFamily: 'Calibri, sans-serif' };
const section = { marginBottom: '44px', scrollMarginTop: '90px' };

const TermsConditions = () => (
    <>
        <SEO
            title="Terms & Conditions"
            description="Read the terms and conditions governing the use of Oottan.com's matrimonial services."
            canonical="/terms-conditions"
        />
        <LegalPageLayout
            title="Terms & Conditions"
            updated="10 Oct 2026"
            sections={SECTIONS}
            currentPath="/terms-conditions"
        >
        <div id="general" style={section}>
            <h2 style={h2}>General Terms</h2>
            <hr style={divider} />
            <p style={p}>
                By accessing and placing an order with Hirehike Technologies Private Limited, you confirm that you
                are in agreement with and bound by the terms of service contained in the Terms &amp; Conditions
                outlined below. These terms apply to the entire website and any email or other type of communication
                between you and Hirehike Technologies Private Limited.
            </p>
            <p style={p}>
                Under no circumstances shall Hirehike Technologies Private Limited be liable for any direct, indirect,
                special, incidental, or consequential damages — including but not limited to loss of data or profit —
                arising out of the use, or the inability to use, the materials on this site, even if Hirehike
                Technologies Private Limited or an authorised representative has been advised of the possibility of
                such damages.
            </p>
            <p style={p}>
                Hirehike Technologies Private Limited will not be responsible for any outcome that may occur during
                the course of usage of our resources. We reserve the right to change prices and revise the resources
                usage policy at any time.
            </p>
        </div>

        <div id="license" style={section}>
            <h2 style={h2}>License</h2>
            <hr style={divider} />
            <p style={p}>
                Oottan grants you a revocable, non-exclusive, non-transferable, limited licence to download,
                install, and use our service strictly in accordance with the terms of this Agreement.
            </p>
            <p style={p}>
                These Terms &amp; Conditions are a contract between you and Oottan (referred to as "Oottan,"
                "us," "we," or "our"), the provider of the Oottan website and the matrimony services
                accessible from it.
            </p>
            <p style={p}>
                You are agreeing to be bound by these Terms &amp; Conditions. If you do not agree, please do not
                use the Service. If you violate any of these Terms, we reserve the right to cancel your account or
                block access to your account without notice.
            </p>
        </div>

        <div id="definitions" style={section}>
            <h2 style={h2}>Definitions and Key Terms</h2>
            <hr style={divider} />
            <ul style={{ paddingLeft: '20px' }}>
                <li style={li}><strong>Cookie:</strong> Small amount of data generated by a website and saved by your web browser. Used to identify your browser, provide analytics, and remember information such as language preference or login information.</li>
                <li style={li}><strong>Company:</strong> Refers to <strong>Hirehike Technologies Private Limited, 8/61/1, Kumbavilai, Veeyanoor – 629177, Kanyakumari District, Tamil Nadu, India</strong>.</li>
                <li style={li}><strong>Device:</strong> Any internet-connected device such as a phone, tablet, or computer that can be used to visit Oottan and use the services.</li>
                <li style={li}><strong>Personal Data:</strong> Any information that directly or indirectly allows for the identification of a natural person.</li>
                <li style={li}><strong>Service:</strong> The matrimony services provided by Oottan as described on this platform.</li>
                <li style={li}><strong>Website:</strong> Oottan, accessible via <a href="https://oottan.com" style={{ color: '#AD1457' }}>https://oottan.com</a>.</li>
                <li style={li}><strong>You:</strong> A person or entity registered with Oottan to use the Services.</li>
            </ul>
        </div>

        <div id="restrictions" style={section}>
            <h2 style={h2}>Restrictions</h2>
            <hr style={divider} />
            <p style={p}>You agree not to, and will not permit others to:</p>
            <ul style={{ paddingLeft: '20px' }}>
                <li style={li}>Licence, sell, rent, lease, assign, distribute, transmit, host, outsource, disclose, or otherwise commercially exploit the service or make the platform available to any third party.</li>
                <li style={li}>Modify, make derivative works of, disassemble, decrypt, reverse compile, or reverse engineer any part of the service.</li>
                <li style={li}>Remove, alter, or obscure any proprietary notice (including any notice of copyright or trademark) of Oottan or its affiliates, partners, suppliers, or the licensors of the service.</li>
            </ul>
        </div>

        <div id="payment" style={section}>
            <h2 style={h2}>Payment</h2>
            <hr style={divider} />
            <p style={p}>
                If you register to any of our recurring payment plans, you agree to pay all fees or charges to your
                account for the Service in accordance with the fees, charges, and billing terms in effect at the time
                that each fee or charge is due and payable. Unless otherwise indicated, you must provide us with a
                valid credit card or other accepted payment method as a condition to signing up for the Premium plan.
            </p>
        </div>

        <div id="refund" style={section}>
            <h2 style={h2}>Return and Refund Policy</h2>
            <hr style={divider} />
            <p style={p}>
                We appreciate the fact that you like to buy the stuff we build. We also want to make sure you have a
                rewarding experience. As with any service, there are terms and conditions that apply to transactions
                at our company. The main thing to remember is that by placing an order or making a purchase, you
                agree to the terms along with our Privacy Policy.
            </p>
            <p style={p}>
                If, for any reason, you are not completely satisfied with any good or service that we provide, don't
                hesitate to contact us and we will discuss any issues you are going through with our product.
            </p>
        </div>

        <div id="consent" style={section}>
            <h2 style={h2}>Your Consent</h2>
            <hr style={divider} />
            <p style={p}>
                We've updated our Terms &amp; Conditions to provide you with complete transparency into what is being
                set when you visit our site and how it's being used. By using our service, registering an account,
                or making a purchase, you hereby consent to our Terms &amp; Conditions.
            </p>
        </div>

        <div id="links" style={section}>
            <h2 style={h2}>Links to Other Websites</h2>
            <hr style={divider} />
            <p style={p}>
                Our service may contain links to other websites that are not operated by us. If you click on a
                third-party link, you will be directed to that third party's site. We strongly advise you to review
                the Terms &amp; Conditions of every site you visit. We have no control over, and assume no
                responsibility for, the content, Terms &amp; Conditions, or practices of any third-party sites
                or services.
            </p>
        </div>

        <div id="cookies" style={section}>
            <h2 style={h2}>Cookies</h2>
            <hr style={divider} />
            <p style={p}>
                We use "Cookies" to identify the areas of our website that you have visited. A Cookie is a small
                piece of data stored on your computer or mobile device by your web browser. We use Cookies to
                enhance the performance and functionality of our service. Without these cookies, certain functionality
                may become unavailable or you would be required to enter your login details every time you visit.
                We never place personally identifiable information in Cookies.
            </p>
        </div>

        <div id="changes" style={section}>
            <h2 style={h2}>Changes to Our Terms &amp; Conditions</h2>
            <hr style={divider} />
            <p style={p}>
                You acknowledge and agree that we may stop providing the Service (or any features within the
                Service) to you at our sole discretion, without prior notice. If we decide to change our Terms &amp;
                Conditions, we will post those changes on this page and update the modification date below.
            </p>
        </div>

        <div id="contact" style={section}>
            <h2 style={h2}>Contact Us</h2>
            <hr style={divider} />
            <p style={p}>Don't hesitate to contact us if you have any questions about these Terms &amp; Conditions.</p>
            <ul style={{ paddingLeft: '20px' }}>
                <li style={li}>Email: <strong>info@oottan.com</strong></li>
                <li style={li}>Phone: <strong>04651-215020</strong></li>
                <li style={li}>Address: <strong>8/61/1, Kumbavilai, Veeyanoor – 629177, Kanyakumari District, Tamil Nadu, India</strong></li>
            </ul>
        </div>
        </LegalPageLayout>
    </>
);

export default TermsConditions;
